import React from 'react'

interface SvgProps {
  fill: string
}

function SvgFastTrack({ fill }: SvgProps) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* First play icon */}
      <path d="M5 4V20L13 12L5 4Z" fill={fill} />
      {/* Second play icon */}
      <path d="M11 4V20L19 12L11 4Z" fill={fill} />
    </svg>
  )
}

export default SvgFastTrack
